import { createAsyncThunk } from "@reduxjs/toolkit";
import TripBackupReminderService from "app/data/services/TripBackupReminderService";

export const checkShouldShowReminderThunk = createAsyncThunk(
  "tripBackupReminder/checkShouldShow",
  async (accountId: string) => {
    const response =
      await TripBackupReminderService.shouldShowReminder(accountId);
    return response;
  }
);

export const dismissReminderThunk = createAsyncThunk(
  "tripBackupReminder/dismiss",
  async (accountId: string) => {
    const response = await TripBackupReminderService.dismissReminder(accountId);
    return response;
  }
);
